import {createContext} from 'react'

import {History} from 'history'

type ParsedQuery = Record<string, string | string[] | undefined>

/**
 * Контекст парсинга QueryString из URL
 */
export const QueryStringContext = createContext<ParsedQuery>({})

/**
 * Контекст парсинга QueryString из хэша в URL
 */
export const HashQueryStringContext = createContext<ParsedQuery>({})

/**
 * Контекст с history (обычной)
 */
export const HistoryContext = createContext<History>(null as unknown as History)
/**
 * Контекст с Hash history
 */
export const HashHistoryContext = createContext<History>(null as unknown as History)

export const HistoryProvider = HistoryContext.Provider
export const HashHistoryProvider = HashHistoryContext.Provider
